var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeading2Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "#D25E6A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5036 26V14.3636H12.9638V19.1648H17.9581V14.3636H20.4126V26H17.9581V21.1932H12.9638V26H10.5036ZM22.3729 26V24.2273L26.5149 20.392C26.8672 20.0511 27.1626 19.7443 27.4013 19.4716C27.6437 19.1989 27.8274 18.9318 27.9524 18.6705C28.0774 18.4053 28.1399 18.1193 28.1399 17.8125C28.1399 17.4716 28.0623 17.178 27.907 16.9318C27.7517 16.6818 27.5395 16.4905 27.2706 16.358C27.0017 16.2216 26.6967 16.1534 26.3558 16.1534C25.9998 16.1534 25.6892 16.2254 25.424 16.3693C25.1589 16.5133 24.9543 16.7197 24.8104 16.9886C24.6664 17.2576 24.5945 17.5777 24.5945 17.9489H22.2592C22.2592 17.1875 22.4316 16.5265 22.7763 15.9659C23.121 15.4053 23.6039 14.9716 24.2251 14.6648C24.8464 14.358 25.5623 14.2045 26.3729 14.2045C27.2062 14.2045 27.9316 14.3523 28.549 14.6477C29.1702 14.9394 29.6532 15.3447 29.9979 15.8636C30.3426 16.3826 30.5149 16.9773 30.5149 17.6477C30.5149 18.0871 30.4278 18.5208 30.2536 18.9489C30.0831 19.3769 29.7782 19.8523 29.3388 20.375C28.8994 20.8939 28.2801 21.517 27.4808 22.2443L25.782 23.9091V23.9886H30.6683V26H22.3729Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeading2Icon);
export default __webpack_public_path__ + "static/media/heading2-icon.efe3ab81.svg";
export { ForwardRef as ReactComponent };